import React from 'react';
import { Progress, ProgressProps } from 'antd';
import { useRequest } from 'ahooks';
import { apiV2HighEnergyDeviceAnalysisV2EnergySummaryPost } from '@maxtropy/device-customer-apis-v2';
import { keepTwoOrLine, keepTwoAndWanOrLine } from '@/utils/utils';
import { DateType } from '../TimeSelector';
import styles from './index.module.scss';

// Progress渐变色
const twoColors: ProgressProps['strokeColor'] = {
  '0%': '#79EDE4',
  '100%': '#44D7B8',
};

export interface TimeParams {
  startTime: number;
  endTime: number;
  timeResolution: DateType;
}

export interface ElectricityCardProps {
  timeParams: TimeParams;
}

const ElectricityCard: React.FC<ElectricityCardProps> = ({ timeParams }) => {
  const { startTime, endTime, timeResolution } = timeParams;

  const { data } = useRequest(
    () =>
      apiV2HighEnergyDeviceAnalysisV2EnergySummaryPost({
        startTime: startTime || undefined,
        endTime: endTime || undefined,
        timeResolution,
      }),
    {
      ready: !!startTime && !!endTime,
      refreshDeps: [startTime, endTime, timeResolution],
    }
  );

  const percent = data?.plantPercentage;
  const totalElectricity = keepTwoAndWanOrLine(data?.totalConsumption);
  const dailyElectricity = keepTwoAndWanOrLine(data?.dailyAverage);

  return (
    <div className={styles.electricityCard}>
      <div className={styles.cardLeft}>
        <Progress
          type="circle"
          size={108}
          percent={percent}
          strokeColor={twoColors}
          trailColor="#28323F"
          strokeWidth={10}
          format={() => (
            <div className={styles.progressContent}>
              <span className={styles.progressPercent}>{keepTwoOrLine(percent)}%</span>
              <span className={styles.progressDesc}>占全厂用电</span>
            </div>
          )}
        />
      </div>
      <div className={styles.cardRight}>
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>总用电量(kWh):</span>
          <span className={styles.cardValue}>{totalElectricity}</span>
        </div>
        <div className={styles.cardDivider} />
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>日均用电(kWh):</span>
          <span className={styles.cardValue}>{dailyElectricity}</span>
        </div>
        <div className={styles.cardDivider} />
        <div className={styles.cardRow}>
          <span className={styles.cardLabel}>总用能成本(元):</span>
          <span className={styles.cardValue}>{keepTwoAndWanOrLine(data?.totalCost)}</span>
        </div>
      </div>
    </div>
  );
};

export default ElectricityCard;
